import firebase from 'firebase'
import config from './config'
firebase.initializeApp(config)
firebase.analytics();
const db = firebase.firestore()


export const login = firebase.auth().signInAnonymously().catch(error => {
    var errorCode = error.code;
    var errorMessage = error.message;
  })

    export const userData = userId =>db.collection('user').doc(userId).get()
  
        
        .then(user =>{ 
          if(user.exists){ 
            user = user.data()
            return{
              newUser: false,
              userInfo: user
            }
          }else{
            return {newUser:true}
          }
        })

    export const addUser = data => { 
        console.log(data);
        
        db.collection('user').doc(data.id).set({ 
          id:data.id,
            name:data.name,
            avatar:data.avatar
        }).then(data => {
            window.location.reload()
        })
        .catch(err=>console.log(err))
        }

    export const getUser= () => {
       var user = firebase.auth().currentUser

       return user
    }

    export const createGame = ()=>{
        var user = firebase.auth().currentUser
        var userdata = userData(user.uid)
        return userdata ;
        
    }
    export const theGame = data =>{
      data = data.userInfo 
      console.log(data);
      
      // data.userId = user.uid
      var gameKey = firebase.database().ref().child('nakbah').push().key;
      data.admin = true

      var gameStuff = { 
        names: [data],
        questions: [false],
        turn:0,
        shuffle: false
      }
      
      var updates = {};
      updates['/nakbah/' + gameKey] = gameStuff;

     firebase.database().ref().update(updates);
    return gameKey;

    }
    
    export const getGameData = (gameId, add)=> { 
      let game = firebase.database().ref('nakbah/'+gameId)
      
      
       game.on('value', snap=>{
        snap = snap.val()
        
        
        add(snap)
      })
    }
   export const addQuestion = (gameId, playerId, gameData, ques)=>{
     let found = false 
    gameData.names.forEach(name => {
       if(name.id == playerId.uid){
         found = true
         console.log('found');
         
       }
    })
    
    if( !found){ 
      addPlayer(gameId, playerId, gameData)
    }

   
    let questions = gameData.questions
    questions.push({ 
      player: playerId.uid,
      question: ques
    })
    questions = questions.filter(data => data != false)

    console.log(questions);
    
    let game = firebase.database().ref('nakbah/'+gameId+'/questions').set(questions)

   }



   export const addPlayer = (gameId, player, gameData) => { 
    let names = gameData.names
    let found = false
    names.forEach(dude => {
      if(dude.id == player.uid){ 
        found = true
      }
    });

   if(!found){
    let game = firebase.database().ref('nakbah/'+gameId+'/names/')
    db.collection('user').doc(player.uid).get()
    .then(user => { 
      user = user.data()
      names.push(user)
      game.set(names)
    })
    .catch(err => console.log(err)
    )
   }
     
  }

  function shuf(array) {
    array.sort(() => Math.random() - 0.5);
    return array
  }
  const suffleQuestions = (questions,names, gameId)=>{ 
    let mix = true
    let mixing = false 
    while(mix){
       mixing = false
      questions = shuf(questions)
      questions.forEach((q,i)=>{
        if(q.player === names[i].id){
          mixing = true
        }
      })
      if(!mixing){ 
        mix = false
      }

    }
  
    console.log(questions);
 
return(questions)

    
  }
  export const shuffle = (gameData, gameId)=>{ 
  let questions =  suffleQuestions(gameData.questions, gameData.names, gameId)
  console.log(questions);
 
  let game = firebase.database().ref('nakbah/'+gameId+'/questions').set(questions)
  var updates = {};
  updates['/nakbah/' +gameId+'/shuffle'] = true;
  let gamse =firebase.database().ref().update(updates);

  }
  export const next =( gameId, turn)=>{
    
    var updates = {};
    updates['/nakbah/' +gameId+'/turn'] = turn+1;
    let gamse =firebase.database().ref().update(updates);
  
  }

  export const playAgain = gameId => {
    var turn = {};
    turn['/nakbah/' +gameId+'/turn'] = 0;
    firebase.database().ref().update(turn);

    var shuffle = {};
    shuffle['/nakbah/' +gameId+'/shuffle'] = false;
    firebase.database().ref().update(shuffle);

    var questions = {};
    questions['/nakbah/' +gameId+'/questions'] = [false];
    firebase.database().ref().update(questions);
  }

  export const quitGame = gameId=>{ 
    firebase.database().ref().child('/nakbah/' +gameId).remove();
  }
  export const kickPlayer = (playerId, gameId, gameData)=> {
    let game = firebase.database().ref('nakbah/'+gameId+'/names/')
    let gameques = firebase.database().ref('nakbah/'+gameId+'/questions/')
    let names = gameData.names
    let questions = gameData.questions
    let removed = false
    names = names.filter(name => {
      if(name.id == playerId && !name.admin){ 
        removed = true
       return name.id != playerId

      }else if(name.admin && name.id == playerId){ 
        alert('you can not kick yourself :))')
        
      }
      return true
    
    } )
    if(removed){ 
      questions = questions.filter(ques => ques.player != playerId)
      if(!questions.length){ 
        questions= [false]
      }
    }    
    game.set(names)
    
    gameques.set(questions)
  }